import React, { useState, useEffect } from 'react';
import Grid from '@mui/material/Grid2';
import { Styles } from '../../../../config/design/styles';
import { withStyles } from '@mui/styles';
import AppAnimate from "../../../components/AppAnimate";
import { useTranslation } from "react-i18next";
import Title from "../../../components/elements/Title";
import {IconButton, Tab, Tabs, Typography, useMediaQuery} from "@mui/material";
import {CalendarClock, Grid2x2Check, MapPinned, Pen, ClipboardList} from "lucide-react";
import { useSearchParams, useNavigate } from 'react-router-dom';
import {theme} from "../../../../config/design/theme";
import MakeUser from "../users/MakeUser";
import CourierAddress from "./components/CourierAddress";
import CourierHours from "./components/CourierHours";
import CourierOrders from "./components/CourierOrders";

function MakeCouriersPage({ create }) {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [tabValue, setTabValue] = useState(searchParams.get('tab') || 'details');
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    useEffect(() => {
        // Sync tab value with query string
        setSearchParams({ tab: tabValue });
    }, [tabValue, setSearchParams]);

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    return (
        <AppAnimate animation='transition.slideUpIn' delay={200} title={!!create ? t('addShop') : t('editShop')}>
            <Grid container spacing={2} justify="center" className="shop-tabs">
                {
                    !create &&
                    <Grid item size={12}>
                        <Tabs
                            style={{ marginBottom: 20 }}
                            value={tabValue}
                            onChange={handleTabChange}
                            textColor="primary"
                            variant={isMobile ? 'scrollable' : ""}
                            scrollButtons={isMobile ? 'auto' : ""}
                            aria-label="Tab"
                            centered={!isMobile}
                            className="tabs-v-container"
                        >
                            <Tab value="details" className="tab-stepper"
                                 label={
                                     <div className="custom_tabs">
                                         <IconButton className='custom_tabs_icon_button'>
                                             <Pen className="lucide-xl"/>
                                         </IconButton>
                                         <Typography component="span">{t('editInfo')}</Typography>
                                     </div>
                                 }
                            />
                            <Tab value="address" className="tab-stepper"
                                 label={
                                     <div className="custom_tabs">
                                         <IconButton className='custom_tabs_icon_button'>
                                             <MapPinned className="lucide-xl"/>
                                         </IconButton>
                                         <Typography component="span">{t('address')}</Typography>
                                     </div>
                                 }
                            />
                            <Tab value="hours" className="tab-stepper"
                                 label={
                                     <div className="custom_tabs">
                                         <IconButton className='custom_tabs_icon_button'>
                                             <CalendarClock className="lucide-xl"/>
                                         </IconButton>
                                         <Typography component="span">{t('courierHours')}</Typography>
                                     </div>
                                 }
                            />
                            <Tab value="orders" className="tab-stepper"
                                 label={
                                     <div className="custom_tabs">
                                         <IconButton className='custom_tabs_icon_button'>
                                             <ClipboardList className="lucide-xl"/>
                                         </IconButton>
                                         <Typography component="span">{t('orders')}</Typography>
                                     </div>
                                 }
                            />
                        </Tabs>
                    </Grid>
                }
                {
                    tabValue === "details" &&
                    <Grid item size={12}>
                        <Title align="left" color="text" className="panel-title">{t('editUser')}</Title>
                        <MakeUser type="courier"/>
                    </Grid>
                }
                {
                    tabValue === "address" &&
                    <Grid item size={12}>
                        <CourierAddress type="courier"/>
                    </Grid>
                }
                {
                    (!create && tabValue === "hours") &&
                    <Grid item size={12}>
                        <CourierHours />
                    </Grid>
                }
                {
                    (!create && tabValue === "orders") &&
                    <Grid item size={12}>
                        <CourierOrders />
                    </Grid>
                }
            </Grid>
        </AppAnimate>
    );
}

export default withStyles(Styles)(MakeCouriersPage);
